<template lang="html">
  <router-link active-class="active" class="prt-bottom-bar-element" exact tag="button" :to="goal">
    <prt-icon :icon="icon" />
    <label>{{name}}</label>
  </router-link>
</template>

<script>
import PrtIcon from './PrtIcon.vue';

export default {
  components: {
    PrtIcon,
  },
  props: {
    goal: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="stylus" scoped>
  @require '../../styles/colors'

  .prt-bottom-bar-element
    color: black-54
    background-color: white
    border: none
    outline: none
    width: 100%
    min-width: 80px
    max-width: 168px
    font-family: 'PT Sans', sans-serif
    font-size: 12px
    font-weight: normal
    padding: 0
    transition: background-color 200ms ease, color 200ms ease

    &.active
      color: positive

    &:active
      background-color: positive
      color: white

    .prt-icon
      display: block
      margin: 0 auto 4px auto
</style>
